import { Cart } from "../../../library-js/php/cart/Cart";
import { Rokojori } from "../Rokojori";

export class RokojoriCart extends Cart
{
  get phpContext()
  {
    return Rokojori.phpContext;
  }
}